var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeatingAreaLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "35px",
    viewBox: "0 0 50 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6895FFF9-CC24-4317-910A-3A188CDE8D55") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOTEL-DETAILS-2",
    transform: "translate(-647.000000, -1988.000000)",
    fill: "#7CBEEA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(10.250000, 111.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(106.750000, 1236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(530.000000, 630.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "seating-area-light",
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9945321,2.5 C39.1345102,2.5 42.4933604,5.859375 42.4933604,10 L42.4933604,12.9296875 C43.2744884,12.65625 44.1181065,12.5 44.9929698,12.5 L44.9929698,10 C44.9929698,4.4765625 40.5171067,0 34.9945321,0 L14.9976566,0 C9.47508202,0 4.99921887,4.4765625 4.99921887,10 L4.99921887,12.5 C5.87408217,12.5 6.71770036,12.6484375 7.49882831,12.9296875 L7.49882831,10 C7.49882831,5.859375 10.8576785,2.5 14.9976566,2.5 L34.9945321,2.5 Z M7.49882831,22.5 L7.49882831,30 L7.49882831,31.25 C7.49882831,31.9375 6.93641618,32.5 6.24902359,32.5 L3.74941415,32.5 C3.06202156,32.5 2.49960944,31.9375 2.49960944,31.25 L2.49960944,20 C2.49960944,18.6171875 3.6166224,17.5 4.99921887,17.5 C6.38181534,17.5 7.49882831,18.6171875 7.49882831,20 L7.49882831,22.5 Z M6.24902359,35 C7.881581,35 9.27198875,33.953125 9.7875332,32.5 L40.2124668,32.5 C40.7280112,33.953125 42.118419,35 43.7509764,35 L46.2505858,35 C48.3205749,35 50,33.3203125 50,31.25 L50,20 C50,17.2421875 47.7581628,15 45.0007811,15 C42.2433995,15 40.0015623,17.2421875 40.0015623,20 L10.006249,20 C10.006249,17.2421875 7.76441181,15 5.00703015,15 C2.24964849,15 0.00781127949,17.2421875 0.00781127949,20 L0,31.25 C0,33.3203125 1.67942509,35 3.74941415,35 L6.24902359,35 Z M9.99843774,30 L9.99843774,22.5 L39.993751,22.5 L39.993751,30 L9.99843774,30 Z M42.4933604,31.25 L42.4933604,30 L42.4933604,22.5 L42.4933604,20 C42.4933604,18.6171875 43.6103734,17.5 44.9929698,17.5 C46.3755663,17.5 47.4925793,18.6171875 47.4925793,20 L47.4925793,31.25 C47.4925793,31.9375 46.9301672,32.5 46.2427746,32.5 L43.7431651,32.5 C43.0557725,32.5 42.4933604,31.9375 42.4933604,31.25 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatingAreaLight);
export default __webpack_public_path__ + "static/media/seating-area-light.323f04d9a753d4933e70b78ba3189120.svg";
export { ForwardRef as ReactComponent };